<div class="modal-header">
    <h5 class="modal-title">Video Player</h5>
    <button class="close-button" (click)="activeModal.dismiss()">×</button>
    
</div>
<div class="modal-body p-0">
    <app-fmv-attribute-visualizer [type]="type" [sensorId]="sensorId" [cameraSessionId]="cameraSessionId"
        [number]="number" [mode]="mode" [startTime]="startTime" [endTime]="endTime" [cameraUrl]="cameraUrl"
        [camera]="camera"></app-fmv-attribute-visualizer>
</div>